/* Kuehn Doggear Theme: Grundverhalten (Scroll-Reveal, Mobilmenue, Cookie-Einstellungen). */
(function () {
  'use strict';

  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var imEditor = window.Shopify && window.Shopify.designMode;

  /* ---------- Reveal: Einblendung beim Scrollen ---------- */
  function revealStarten(wurzel) {
    var elemente = (wurzel || document).querySelectorAll('[data-reveal]:not(.sichtbar)');
    if (!elemente.length) return;
    if (wenigBewegung || imEditor || !('IntersectionObserver' in window)) {
      elemente.forEach(function (el) { el.classList.add('sichtbar'); });
      return;
    }
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (eintrag) {
        if (!eintrag.isIntersecting) return;
        eintrag.target.classList.add('sichtbar');
        beobachter.unobserve(eintrag.target);
      });
    }, { rootMargin: '0px 0px -80px 0px' });
    elemente.forEach(function (el) { beobachter.observe(el); });
  }

  /* ---------- Mobilmenue ---------- */
  function menueStarten() {
    var knopf = document.querySelector('[data-menue-knopf]');
    var menue = document.querySelector('[data-menue]');
    if (!knopf || !menue) return;
    var iconAuf = knopf.querySelector('[data-menue-icon-auf]');
    var iconZu = knopf.querySelector('[data-menue-icon-zu]');

    function setze(offen) {
      menue.hidden = !offen;
      knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
      knopf.setAttribute('aria-label', offen ? 'Menü schließen' : 'Menü öffnen');
      if (iconAuf) iconAuf.hidden = offen;
      if (iconZu) iconZu.hidden = !offen;
      document.documentElement.style.overflow = offen ? 'hidden' : '';
      if (offen) {
        var erster = menue.querySelector('a');
        if (erster) erster.focus();
      }
    }

    knopf.addEventListener('click', function () { setze(menue.hidden); });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menue.hidden) { setze(false); knopf.focus(); }
    });
    /* Sobald die Kopfzeile ihre Navigation zeigt, verschwindet der Knopf (ab 1024 px, bei sechs und mehr Punkten ab 1280 px): dann schliesst das Menue. */
    function beiBreitemFenster() {
      if (!menue.hidden && window.getComputedStyle(knopf).display === 'none') setze(false);
    }
    window.addEventListener('resize', beiBreitemFenster);
    menue.addEventListener('click', function (e) {
      if (e.target.closest('a')) setze(false);
    });
  }

  /* ---------- Cookie-Einstellungen ---------- */
  /* Der Knopf in der Fusszeile oeffnet den Banner der App Pandectes wieder. Deren eigenes,
     schwebendes Symbol (.cc-revoke) ist ausgeblendet (teile/banner.css) und wird von hier ausgeloest. */
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest ? e.target.closest('[data-cookie-einstellungen]') : null;
    if (!knopf) return;
    e.preventDefault();
    var symbol = document.querySelector('.cc-revoke');
    if (symbol) {
      symbol.click();
      return;
    }
    var app = window.Pandectes;
    if (app && app.fn && typeof app.fn.revokeConsent === 'function') app.fn.revokeConsent();
  });

  function start() {
    revealStarten();
    menueStarten();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Im Theme-Editor neu geladene Abschnitte sofort sichtbar machen */
  document.addEventListener('shopify:section:load', function (e) { revealStarten(e.target); });

  window.KuehnTheme = { revealStarten: revealStarten };
})();
